export const FREE_SHIPPING_THRESHOLD = 50;

export const unitPrice = (product) => {
  const price = Number(product?.price) || 0;
  const discount = Number(product?.discount) || 0;
  if (discount <= 0) return price;
  return price - (price * discount) / 100;
};

export const lineTotal = (product, quantity) => {
  const qty = Number(quantity ?? product?.quantity) || 0;
  return unitPrice(product) * qty;
};

export const merchandiseTotal = (items) =>
  (items || []).reduce((sum, item) => sum + lineTotal(item), 0);

export const freeShippingProgress = (total) => {
  const amount = Math.max(0, Number(total) || 0);
  const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - amount);
  const ratio = Math.min(1, amount / FREE_SHIPPING_THRESHOLD);
  return {
    remaining,
    ratio,
    qualified: amount >= FREE_SHIPPING_THRESHOLD,
  };
};
